class CollapsibleContent extends HTMLElement {
  constructor() {
    super();

    this.opened = false;
    this.summary = this.querySelector(".summary");
    this.wrapper = this.querySelector(".wrapper");
    this.content = this.querySelector(".content");
    this.contentHeight = this.content.clientHeight;

    this.bindEvent();
  }

  bindEvent() {
    this.summary.addEventListener("click", () => {
      if (this.opened) {
        this.wrapper.style.height = "0px";
        this.summary.classList.remove("opened");
        this.opened = false;
      } else {
        this.wrapper.style.height = `${this.content.clientHeight}px`;
        this.summary.classList.add("opened");
        this.opened = true;
      }
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth > 640) {
        this.reset();
      }
    });
  }

  reset() {
    this.wrapper.style = {};
    this.opened = false;
  }
}

customElements.define("collapsible-content", CollapsibleContent);
